import React from "react";
import Pagination from "./Pagination";
import useWindowWidth from "../utils/windowWidth";

const getDocumentDownload = (item: any) => {
  const sourceFileName = String(item.fileName || "converted-document");
  const baseName = sourceFileName.replace(/\.[^/.]+$/, "") || "converted-document";
  const extension = String(item.outputFormat || "DOCX")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "") || "docx";

  return {
    url: item.remediatedUrl || item.url,
    fileName: `${baseName}.${extension}`,
  };
};


export const Card = (props: any) => {
  const formatDate = (dateString: any) => {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleString("en-US", {
      day: "2-digit", // Numeric, 2-digit day
      month: "short", // Short month name
      hour: "2-digit", // 2-digit hour
      minute: "2-digit", // 2-digit minutes
      hour12: true, // Use 12-hour time format
    });
    return formattedDate;
  };
  const download = getDocumentDownload(props.item);

  return (
      <article className="doc-request-card-wrapper">
        <div
          // onClick={onToggle} // Use the toggle function passed from parent
          className="opportunity-card news-article doc-card"
        >
          <div
            className="doc-card-layout"
          >
            <div
              className="doc-card-details"
            >
              <div
                className="doc-card-copy"
              >
                <h3 className="card-title news-title doc-name">
                      {props.item.fileName}
                </h3>
                <p className="doc-card-meta">
                  <span>TAG</span>{props.item.tag}
                </p>
                {!props.sourceSelected && (
                  <p
                    className="card-text"
                    style={{ fontWeight: "500" }}
                  >
                    <span>UPLOAD DATE</span>{formatDate(props.item.createdAt)}
                  </p>
                )}
              </div>
            </div>
            <div className="doc-card-actions">
                <div className="doc-card-status">
                    <div
                      className={props.item.isDownloadable ? "completed" : "pending"}
                    >
                      {props.item.isDownloadable ? "Success" : "In Progress"}
                    </div>
                  </div>
                  <div className="doc-card-download">
                  {props.item.isDownloadable && (
                    <a
                      href={download.url}
                      download={download.fileName}
                      aria-label={`Download ${download.fileName}`}
                    >
                      {props.item.isDownloadable ? (
                        <img
                          src="/download.svg"
                          alt=""
                          aria-hidden="true"
                        />
                      ) : (
                        ""
                      )}
                    </a>
                  )}
                  </div>
          </div>
          </div>
        </div>
      </article>
  );
};


const DocList = (props: any) => {
  //     let docList:any[] = [{
  //      name : "Linked Premium",
  //      tag: "t1",
  //      status: "Completed",
  //      src: "not found",
  //      convert: "some link",
  //      actions: "popy",
  //      uploadDate: "Jun 7, 2024, 7:47:02 PM"
  //     },
  //     {
  //         name : "Linked Premiefsefasdadaswdafaefeafesf",
  //         tag: "",
  //         status: "Completed",
  //         src: "not found",
  //         convert: "some link",
  //         actions: "ffb",
  //         uploadDate: "Jun 7, 2024, 7:47:02 PM"
  //        }
  // ];
  let docList: any[] = props.docList;

  const formatDate = (dateString: any) => {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleString("en-US", {
      day: "2-digit", // Numeric, 2-digit day
      month: "short", // Short month name
      hour: "2-digit", // 2-digit hour
      minute: "2-digit", // 2-digit minutes
      hour12: true, // Use 12-hour time format
    });
    return formattedDate;
  };


  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;
  
  return (
    <section aria-labelledby="doc-list-section" className="doc-list-section">
      <h2 id="doc-list-section" className="sr-only">Document List</h2>
      {props.isLoading && <p role="status">Loading previous document requests…</p>}
      {!props.isLoading && docList.length === 0 && (
        <p role="status">No previous document requests found.</p>
      )}
      {!props.isLoading && docList.length > 0 && !isMobile && <table className="doc-list" style={{ tableLayout: "fixed" }} aria-labelledby="doc-list-section">
        <colgroup>
          <col style={{ width: "25%", minWidth: "25%" }} />
          <col style={{ width: "20%", minWidth: "20%" }} />
          <col style={{ width: "15%", minWidth: "25%" }} />
          <col style={{ width: "25%", minWidth: "15%" }} />
          <col style={{ width: "15%", minWidth: "15%" }} />
        </colgroup>
        <thead className="list-head">
          <tr className="list-head-row">
            <th scope="col">DOCUMENT NAME</th>
            <th scope="col">TAG</th>
            <th scope="col">UPLOAD DATE</th>
            <th scope="col">
              <div className="d-flex justify-center h-[100%]">
                CURRENT STATUS
              </div>
            </th>
            <th scope="col">
              <div className="d-flex justify-center h-[100%]">ACTION</div>
            </th>
          </tr>
        </thead>
        <tbody className="table-body">
          {docList.map((item: any, index: any) => {
            const download = getDocumentDownload(item);
            return (
              <tr className="list-row" key={item._id || item.url || index}>
                <td className="doc-name">{item.fileName}</td>
                <td>{item.tag}</td>
                <td>{item.createdAt ? formatDate(item.createdAt) : "--"}</td>
                <td>
                  <div className="d-flex justify-center items-center">
                    <div
                      className={item.isDownloadable ? "completed" : "pending"}
                    >
                      {item.isDownloadable ? "Success" : "In Progress"}
                    </div>
                  </div>
                </td>
                <td>
                  {item.isDownloadable && (
                    <a
                      href={download.url}
                      download={download.fileName}
                      aria-label={`Download ${download.fileName}`}
                    >
                      {item.isDownloadable ? (
                        <img
                          src="/download.svg"
                          alt=""
                          aria-hidden="true"
                        />
                      ) : (
                        ""
                      )}
                    </a>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>}
      {!props.isLoading && isMobile &&
                docList.map((item: any, index: any) => {
                  //Processing the article body to remove "Also read" lines
                  return (
                    <Card
                      item={item}
                      key={item._id || item.url || index}
                    />
                  );
                })}
      {!props.isLoading && docList.length > 0 && <nav className="pagination-container" aria-label="Document request pages">
        {/* <div className="pagination">
       
        <a >previous</a>
        <a  className="middle" aria-current="page">1</a>
        <a>next</a>
    </div> */}
        <Pagination
          pageNumber={props.page}
          totalPages={props.totalPages}
          onPageChange={props.onPageChange}
        />
      </nav>}
    </section>
  );
};

export default DocList;
